import { BaseService } from '@flint/framework';

export default class AddAdmin extends BaseService {
    constructor() {
        super("ADDING_ADMIN_DATA", 'AddAdminStore', true);
    }

    handleEvent(eventName, admin) {
        return this.getClient('vetService').post('/admin-api/users/', admin);
    }
}